<div class="container">
    <div class="col-md-12 lease_table">
        <div>
            <div class="d-flex list">
                <div class="migration_detials">Hygine Report</div>
                <button (click)="onBtExport()" class="mb-2">
                    Download Excel</button>
            </div>
            <div class="col-md-12">
                <!-- <section class="section_one" >
                    <div class="cctvcouncelling__sec">
                        <div class="councellist__flex">
                            <div>
                                <div class="nodata_center">
                                    <figure class="mb-0">
                                        <img src="../../assets/image/nodata.png " alt="nodata" class="nodata">
                                    </figure>
                                    <p class="no_data">No Data Found</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> -->
                <section>
                    <div class="table_data ">

                        <!-- <ag-grid-angular style="width: 100%; " class="ag-theme-alpine  ag-grid-custom" [rowData]="rowData"
                            [columnDefs]="columnDefs" [pagination]="true" [paginationPageSize]="50"
                            [quickFilterText]="quickFilter" [defaultExcelExportParams]="defaultExcelExportParams"
                            (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"  [gridOptions]="gridOptions"  
                          >
                        </ag-grid-angular> -->
                        <div class="grid-wrapper">
                            <ag-grid-angular
                             class="ag-theme-alpine " [rowData]="rowData" [columnDefs]="columnDefs"
                                [pagination]="true" [paginationPageSize]="50" [gridOptions]="gridOptions"
                                domLayout="normal" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
                                style="width: 100%; height: 100%;">
                            </ag-grid-angular>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>


<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>